import type { Importance } from '@/shared/types'

const MAP: Record<Importance, { color: string; label: string }> = {
  critical: { color: 'var(--color-danger)', label: 'Kritisk' },
  high: { color: 'var(--color-ink-1000)', label: 'Hög' },
  medium: { color: 'var(--color-clay)', label: 'Medel' },
  low: { color: 'var(--color-ink-300)', label: 'Låg' },
}

interface Props {
  level: Importance
}

export default function ImportanceFlag({ level }: Props) {
  const v = MAP[level] || MAP.medium
  return (
    <span
      className="text-[9px] font-bold uppercase tracking-widest border border-current px-1.5 py-0.5 rounded-[2px] shrink-0 w-16 text-center"
      style={{ color: v.color }}
    >
      {v.label}
    </span>
  )
}
